import { resolveImageAlt, toLightboxSlides } from '@eliadmin/core/src/utils/image-alt-utils';

/** Legacy DZL imports duplicated the opaque filename stem into both text fields. */
function galleryImage(image: unknown, productName: unknown): unknown {
  if (!image || typeof image !== 'object' || Array.isArray(image)) return image;
  if (typeof productName !== 'string' || !productName.trim()) return image;
  const media = image as Record<string, unknown>;
  if (typeof media.name !== 'string' || typeof media.url !== 'string') return image;
  const match = /^([a-f0-9]{32})\.(?:jpe?g|png|webp|gif)$/i.exec(media.name);
  if (!match || media.custom_title !== match[1] || media.alt !== match[1]) return image;
  if (
    media.is_ai_generated !== false ||
    media.is_decorative != null ||
    media.description != null ||
    media.alt_locale != null ||
    media.metadata != null ||
    media.altText != null
  )
    return image;
  try {
    if (decodeURIComponent(new URL(media.url).pathname.split('/').pop() ?? '') !== media.name)
      return image;
  } catch {
    return image;
  }
  return { ...media, custom_title: undefined, alt: undefined };
}

export function resolveDzlGalleryImageAlt(image: unknown, productName: unknown): string {
  return resolveImageAlt(galleryImage(image, productName), productName);
}

export function toDzlGallerySlides(images: unknown, productName: unknown) {
  return toLightboxSlides(
    Array.isArray(images) ? images.map(image => galleryImage(image, productName)) : images,
    productName,
  );
}
